import { ServiceTokens } from "$src/domain/ServiceTokens";
import { DocumentIdentifier } from "$src/domain/projects/documents/DocumentIdentifier";
import type { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class DeleteDocument {
    
    constructor(@inject(ServiceTokens.DocumentRepository) private documentRepository: IDocumentRepository) {}

    async execute(groupStoreId: number, projectId: number, documentId: string): Promise<DocumentIdentifier> {

        var identifier = await this.documentRepository.deleteDocument(groupStoreId, projectId, documentId);

        return identifier;
    }
}

export const DeleteDocumentToken = Symbol('DeleteDocumentToken');